import React, { Component } from "react";
import { Redirect } from "react-router";
import accountService from "../../../services/AccountService";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import Type from "../../Global/Typography.js";

import NanoFlex from "./../../Global/NanoFlex.js";
import Input from "./../../Nano/Input.js";
import Button from "./../../Nano/Buttons/Button.js";
import Spinner from "./../../Nano/Spinner.js";

import { validateEmailFormat, validateNumericEvent } from "./../../Global/tools.js";

//Images
import backgroundImage from "../../../images/bck-login.svg";
import { ReactComponent as Check } from "./../../Global/Icons/check.svg";

const multiple = nota.global.multiple;

const StyledFreeTrial = styled(NanoFlex)`
  height: 100vh;
  background-color: ${nota.color.main.default};
  background-image: url(${backgroundImage});
  background-repeat: no-repeat, repeat;
  background-size: cover;
  background-position: center;

  .formWrapper {
    background-color: ${nota.color.neutral.white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: ${multiple * 3 + "px"};
    width: 40%;
    height: auto;
    .titleForm {
      h2 {
        margin-bottom: ${multiple * 2 + "px"};
      }
    }
    .formContainer {
      .form-wrapper {
        .formLine {
          width: 100%;
          .inputWrapper {
            margin-top: ${multiple + "px"};
            margin-right: ${multiple + "px"};
            .inputContainer {
              margin: 0;
              width: 100%;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        p {
          margin: ${multiple + "px"} 0;
        }
        textarea {
          font-family: ${nota.font};
          width: 100%;
          height: 15vh;
          overflow: auto;
          border: 1px solid ${(props) => (props.error ? nota.color.main.mTwo : nota.color.neutral.NeuTwo)};
          padding: 10px;
          width: 100%;
          font-size: 12px;
          color: ${nota.color.neutral.NeuOne};
          resize: none;
          &::placeholder {
            color: ${nota.color.neutral.NeuTwo};
          }
        }
      }
      .form-wrapper {
        width: 100%;
        .inputContainer {
          margin: ${multiple * 2 + "px"} auto;
        }
        .buttonsWrapper {
          margin-top: ${multiple * 2 + "px"};
          .buttonWrapper {
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }

  /* NOTIFICATION */
  .wrapperNotification {
    height: 558px;
    .iconWrapper {
      padding: 72px 72px 0px 72px;
      svg {
        height: 100px;
        width: auto;
      }
    }
    .infoNotification {
      text-align: center;
      padding: ${multiple * 2 + "px"};
      h3 {
        color: ${nota.color.neutral.NeuOne};
        text-transform: uppercase;
        font-weight: bold;
      }
    }
    .buttonsWrapper {
      height: auto;
    }
  }

  /* LOADING  */
  .loadingContainer {
    height: 558px;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-height: 635px) {
    .formWrapper {
      width: 60%;
      .formContainer {
        .form-wrapper {
          textarea {
            height: 38px;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 800px) {
    align-items: flex-start;
    padding: 16px;
    height: initial;
    min-height: 100%;
    .formWrapper {
      width: 100%;
      .formContainer {
        .form-wrapper {
          height: 100%;
          .titleForm {
            height: auto;
          }
          .formLine {
            flex-direction: column;
            .inputWrapper {
              margin-right: 0px;
            }
          }
        }
      }
    }
    .wrapperNotification {
      height: auto;
      height: calc(100vh - 266px);
      .iconWrapper {
        padding: 54px 72px 0px 72px;
      }
    }
    /* LOADING  */
    .loadingContainer {
      height: calc(100vh - 266px);
    }
  }
`;

export class FreeTrial extends Component {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      firstName: "",
      firstNameError: false,

      lastName: "",
      lastNameError: false,

      country: "",
      countryError: false,

      phoneNumber: "",
      phoneNumberError: false,

      jobTitle: "",
      jobTitleError: false,

      companyName: "",
      companyNameError: false,

      email: "",
      emailError: false,

      message: "",
      messageError: false,

      success: false,
      loading: false,
    };
  };

  onFirstNameChange = (value) => {
    this.setState({ firstName: value });
  };

  onLastNameChange = (value) => {
    this.setState({ lastName: value });
  };

  onCountryChange = (value) => {
    this.setState({ country: value });
  };

  onPhoneNumberChange = (value) => {
    this.setState({ phoneNumber: value });
  };

  onPhoneNumberKeyDown = (e) => {
    if (!validateNumericEvent(e) && !((this.state.phoneNumber ?? "") === "" && e.key == "+")) {
      // input is INVALID
      e.returnValue = false;
      if (e.preventDefault) e.preventDefault();
    }
  };

  onJobTitleChange = (value) => {
    this.setState({ jobTitle: value });
  };

  onCompanyNameChange = (value) => {
    this.setState({ companyName: value });
  };

  onEmailChange = (value) => {
    this.setState({ email: value });
  };

  onMessageChange = (value) => {
    this.setState({ message: value });
  };

  backToLogin = () => {
    this.setState(this.getDefaultState());
    if (this.props.nextAction) this.props.nextAction();
  };

  validateFields = () => {
    let firstNameError = false;
    let lastNameError = false;
    let countryError = false;
    let phoneNumberError = false;
    let jobTitleError = false;
    let companyNameError = false;
    let emailError = false;
    let messageError = false;
    let isValid = true;

    if (!this.state.firstName || this.state.firstName.trim() == "") {
      firstNameError = true;
      isValid = false;
    }

    if (!this.state.lastName || this.state.lastName.trim() == "") {
      lastNameError = true;
      isValid = false;
    }

    if (!this.state.country || this.state.country.trim() == "") {
      countryError = true;
      isValid = false;
    }

    if (!this.state.phoneNumber || this.state.phoneNumber.trim() == "") {
      phoneNumberError = true;
      isValid = false;
    }

    if (!this.state.jobTitle || this.state.jobTitle.trim() == "") {
      jobTitleError = true;
      isValid = false;
    }

    if (!this.state.companyName || this.state.companyName.trim() == "") {
      companyNameError = true;
      isValid = false;
    }

    if (!this.state.email || this.state.email.trim() == "" || validateEmailFormat(this.state.email) == false) {
      emailError = true;
      isValid = false;
    }

    if (!this.state.message || this.state.message.trim() == "") {
      messageError = true;
      isValid = false;
    }

    this.setState({
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      countryError: countryError,
      phoneNumberError: phoneNumberError,
      jobTitleError: jobTitleError,
      companyNameError: companyNameError,
      emailError: emailError,
      messageError: messageError,
    });

    return isValid;
  };

  freeTrial = () => {
    if (this.validateFields()) {
      this.setState({ loading: true }, () => {
        accountService
          .freeTrial({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            country: this.state.country,
            phoneNumber: this.state.phoneNumber,
            jobTitle: this.state.jobTitle,
            companyName: this.state.companyName,
            email: this.state.email,
            message: this.state.message,
          })
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
          })
          .then((data) => {
            this.setState({ loading: false, success: true });
          });
      });
    }
  };

  render() {
    return (
      <StyledFreeTrial>
        <NanoFlex className="formWrapper" flexDirection="column">
          <NanoFlex className="titleForm" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <Type.h2>
              <b>NOTA</b> Free Trial
            </Type.h2>
            <Type.p>Thank you for your interest in Glance's monitoring tool for new formats and programming trends. </Type.p>
            <Type.p>Do not hesitate to submit your request by completing the form here under. </Type.p>
            <Type.p>The team will come back to you shortly. </Type.p>
          </NanoFlex>
          {this.state.loading && (
            <NanoFlex className="loadingContainer">
              <Spinner />
            </NanoFlex>
          )}

          {!this.state.loading && !this.state.success && (
            <NanoFlex className="formContainer">
              <form className="form-wrapper">
                <NanoFlex className="formLine">
                  <NanoFlex className="inputWrapper">
                    <Input title="First Name" placeholder="First Name" defaultValue={this.state.firstName} onChangeAction={this.onFirstNameChange} error={this.state.firstNameError} />
                  </NanoFlex>
                  <NanoFlex className="inputWrapper">
                    <Input title="Last Name" placeholder="Last Name" defaultValue={this.state.lastName} onChangeAction={this.onLastNameChange} error={this.state.lastNameError} />
                  </NanoFlex>
                </NanoFlex>

                <NanoFlex className="formLine">
                  <NanoFlex className="inputWrapper">
                    <Input title="Country" placeholder="Country" defaultValue={this.state.country} onChangeAction={this.onCountryChange} error={this.state.countryError} />
                  </NanoFlex>
                  <NanoFlex className="inputWrapper">
                    <Input title="Phone Number" placeholder="Phone Number" forceValue defaultValue={this.state.phoneNumber} onChangeAction={this.onPhoneNumberChange} onKeyDown={this.onPhoneNumberKeyDown} error={this.state.phoneNumberError} />
                  </NanoFlex>
                </NanoFlex>

                <NanoFlex className="formLine">
                  <NanoFlex className="inputWrapper">
                    <Input title="Job Title" placeholder="Job Title" defaultValue={this.state.jobTitle} onChangeAction={this.onJobTitleChange} error={this.state.jobTitleError} />
                  </NanoFlex>
                  <NanoFlex className="inputWrapper">
                    <Input title="Company Name" placeholder="Company Name" defaultValue={this.state.companyName} onChangeAction={this.onCompanyNameChange} error={this.state.companyNameError} />
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="formLine">
                  <NanoFlex className="inputWrapper">
                    <Input title="E-mail" placeholder="Your E-mail" defaultValue={this.state.email} onChangeAction={this.onEmailChange} error={this.state.emailError} />
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="formLine" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                  <Type.p style={{ color: this.state.messageError ? nota.color.main.mTwo : nota.color.main.defaultTwo }}>Message</Type.p>
                  <textarea
                    style={{ border: `1px solid ${this.state.messageError ? nota.color.main.mTwo : nota.color.neutral.NeuTwo}` }}
                    value={this.state.message}
                    placeholder="Write your message..."
                    onChange={(e) => {
                      this.onMessageChange(e.target.value);
                    }}></textarea>
                </NanoFlex>
                <NanoFlex className="buttonsWrapper" flexDirection="column">
                  <Button label={"Confirm"} type={"button"} clickAction={this.freeTrial} />
                </NanoFlex>
              </form>
            </NanoFlex>
          )}

          {/* SUCESS MENSAGE */}
          {!this.state.loading && this.state.success && (
            <NanoFlex className="wrapperNotification" flexDirection="column">
              <NanoFlex className="iconWrapper">
                <Check />
              </NanoFlex>

              <NanoFlex className="infoNotification">
                <Type.h3>Your email was sent successfully!</Type.h3>
              </NanoFlex>
            </NanoFlex>
          )}
          {/* END SUCESS MENSAGE */}
        </NanoFlex>
      </StyledFreeTrial>
    );
  }
}
